const formHandler = {
    form: undefined,
    setCurrentForm(validatedForm) {
        this.form = validatedForm.currentForm;
        this.simpleUser = $(this.form).find('.date-select').hasClass('js--birthday');
        return this;
    },
    nds() {
        const $nds = $(this.form).find('#nds');
        if ($nds.length > 0) {
            return $nds.is(':checked') ? '1' : '0';
        }
        return false;
    },
    getExtraPhones(){
        const $phones = $(this.form).find('.js--extra_phone').not('.hidden');
        let phonesVal = '';
        if ($phones.length > 0) {
            $phones.each(function () {
                phonesVal += `${$(this).find('input').val()};`;
            });
            return phonesVal;
        }
        return false;
    },
    prepareData() {
        const selects = $(this.form).find('.js--dropdown-selected');
        const days = selects.filter('[name="days"]').val();
        const years = selects.filter('[name="years"]').val();
        const months = selects.filter('[name="months"]').val();
        const city = selects.filter('[name="city"]').val();
        const certificateDate = `&certificate_date=${years}-${months}-${days}`;
        const birthday = `&years=${years}&months=${months}&days=${days}`;
        let serialized = $(this.form).find('input:not(.js--dropdown-selected), textarea').not('.js--dropdown-selected').serialize();
        const nds = formHandler.nds();
        const phones = formHandler.getExtraPhones();
        const taxForm = selects.filter('[name="tax_form"]').val()
        serialized += this.simpleUser ? birthday : certificateDate;
        if (nds) {
            serialized += `&nds=${nds}`;
        }
        if (phones) {
            serialized += `&phones[]=${phones}`;
        }
        if (city) {
            serialized += `&city=${city}`;
        }
        if (taxForm) {
            serialized += `&tax_form=${taxForm}`;
        }
        serialized += '&ajax=true';

        return serialized;
    },
    registration() {
        $.ajax({
            url: $(this.form).attr('action'),
            type: $(this.form).attr('method'),
            data: formHandler.prepareData(),
            success(rsp) {
                console.log(rsp);
                const response = JSON.parse(rsp);
                if (!response.hasError && response.isSaved) {
                    formHandler.showSuccessMessage(response);
                    formHandler.reInitForm();
                    $('.global_form_errors').slideUp('slow');
                } else if (response.hasError) {
                    formHandler.showErrorMessage(response.errors);
                }
            },
        });
    },
    identity() {
        const submitBtn = $(this.form).find(':submit');
        // submitBtn.addClass('btn--disabled');
        $.ajax({
            url: $(this.form).attr('action'),
            type: $(this.form).attr('method'),
            data: formHandler.prepareData(),
            success(rsp) {
                const response = JSON.parse(rsp);
                if (!response.errors) {
                    formHandler.showEditSuccessMessage(response);
                // submitBtn.removeClass('btn--disabled')
                } else if (response.errors) {
                    formHandler.showErrorMessage(response.errors);
                }
            },
        });
    },

    login() {
        const $globalErrors = $('.global_form_errors');
        if ($globalErrors.length > 0) {
            $globalErrors.removeClass('reinit');
        }
        $.ajax({
            url: $(this.form).attr('action'),
            type: $(this.form).attr('method'),
            data: $(this.form).serialize(),
            success(rsp) {
                const response = JSON.parse(rsp);
                if (response.hasError) {
                    formHandler.showErrorMessage(response.errors);
                } else {
                    location.reload();
                }
            },
        });
    },
    question() {
        const $form = $(this.form);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success(rsp) {
                const response = JSON.parse(rsp);
                if (response.hasError) {
                    formHandler.showErrorMessage(response.errors);
                } else {
                    formHandler.showCallBackSuccessMessage();
                    $form[0].reset();
                }
            },
        });
    },
    callBack() {
        const $form = $(this.form);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success(rsp) {
                console.log(rsp);
                const response = JSON.parse(rsp);
                if (response.errors) {
                    formHandler.showErrorMessage(response.errors);
                } else {
                    !function(f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function() {
                            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = !0;
                        n.version = '2.0';
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = !0;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

                    fbq('init', '1478673465965180');
                    fbq('track', 'Lead');
                    $form.closest('.call_back').addClass('call_back--success');
                    $form.closest('.join_tour_modal').addClass('join_tour_modal--success');
                }
            },
        });
    },
    showErrorMessage(errors) {
        const gerr = $(this.form).find('.global_form_errors').html('');
        gerr.slideUp('slow');
        $.each(errors, (key, val) => {
            const $input = $(formHandler.form).find(`input[name=${key}]`);
            if ($input.length > 0) {
                $input.closest('.form-group').addClass('form-group--error');
                $input.siblings('.form__error_wrapper').html(val);
            } else {
                gerr.append(`<li>${val}</li>`).slideDown('slow');
            }
        });
    },
    showSuccessMessage(rsp) {
        if (this.simpleUser) {
            location.reload();
        } else {
            const $modalSuccess = $('#modal-registration-success');
            if (rsp.success_message.length > 0) {
                $modalSuccess.find('.modal_success__text').text(rsp);
            }
            $modalSuccess.modal('show');
        }
    },
    showEditSuccessMessage() {
        const $modalSuccess = $('#modal_edit_success');
        $modalSuccess.modal('show');
    },
    showCallBackSuccessMessage() {
        const $modalSuccess = $('#modal_callback_success');
        $modalSuccess.modal('show');
    },
    cleanForm() {
        $(this.form).find('input').val('');
        $(this.form).find('textarea').val('');
    },
    reInitForm() {
        formHandler.cleanForm();
        setTimeout(() => {
            $(formHandler.form).closest('.js--parent-form').removeClass('show_response');
        }, 5000);
    },
    // ---- Checkout -----
    userDetectedSubmit() {
        formHandler.checkoutLoginSend(
            $('.opc-user-data input[name="phone"]'),
            $('#modal_user_detected input[name="passwd"]'),
        );
    },
    checkoutLoginSend(login = false, phoneNumber = false) {
        const $log = login || $('input[name="phone_login"]');
        const $pass = phoneNumber || $('input[name="login_passwd"]');
        const $currentForm = $pass.closest('.js--form_wrapper');
        $.ajax({
            url: `${authenticationUrl}?rand=${new Date().getTime()}`,
            type: 'post',
            data: {
                SubmitLogin: true,
                ajax: true,
                phone: $log.val().trim(),
                passwd: $pass.val(),
            },
            dataType: 'json',
            beforeSend() {
                $('.global_form_errors').slideUp('slow');
            },
            complete() {

            },
            success(json) {
                const static_token = json.token;
                if (json.hasError) {
                    let errors = '';
                    for (const error in json.errors)
                    // IE6 bug fix
                    {
                        if (error !== 'indexOf') { errors += `<li>${json.errors[error]}</li>`; }
                    }
                    errors += '';
                    $currentForm.find('.global_form_errors').html(`<ul>${errors}</ul>`).slideDown('slow');
                } else {
                    setTimeout(() => {
                        $currentForm.find('.global_form_errors').slideUp(700, () => {
                            location.reload();
                        });
                    }, 500);
                }
            },
            error(xhr, ajaxOptions, thrownError) {
                alert(`${thrownError}\r\n${xhr.statusText}\r\n${xhr.responseText}`);
            },
        });
    },
    forgotPasswordSubmit() {
        const email = $(formHandler.form).find('input[name="forgot_email"]').val();
        $.ajax({
            type: 'POST',
            url: orderOpcUrl,
            async: false,
            cache: false,
            dataType: 'json',
            data: `email=${email}&ajx=true&method=forgot&token=${static_token}`,
            beforeSend() {
                // $('span.spin').show();
                // $(this.form).find('.global_form_errors').slideUp('slow');
                // $('#forgot_form_content .opc-alert-success').slideUp('slow');
                $('.global_form_errors').slideUp('slow');
                $('.global_form_success').slideUp('slow');
            },
            complete() {

            },
            success(json) {
                const static_token = json.token;
                if (json.hasError) {
                    formHandler.showErrorMessage(json.errors);
                }
                if (json.confirmation == 1) {
                    $(formHandler.form).find('.global_form_success').slideDown('slow');
                    setTimeout(() => {
                        $('#modal_forgot_password').modal('hide');
                        $(formHandler.form)[0].reset();
                    }, 2000);
                }
            },
            error(XMLHttpRequest, textStatus, errorThrown) {
                alert(`TECHNICAL ERROR: unable to loal forgot \n\nDetails:\nError thrown: ${XMLHttpRequest}\n` + `Text status: ${textStatus}`);
            },
        });
    },
    initCheckOutHandlers() {
        $('.place_order').click(function () {
            $('.payment_error, .carrier_error').slideUp('slow');
            const hasc = $('.btn_reg').hasClass('opc-active');
            $('.opc-close').click();
            if (!hasc) { $('.btn_reg').click(); }

            const payment_method = $('input:radio[name=id_payment_method]:checked').val();
            let vcart = $('input[name="vcart"]').val();
            if (vcart == 0) { vcart = false; }
            const term_select = $('input[name="cgv_accept"]').is(':checked');
            $('.opc-form-group').attr({ error: '' }).removeClass('opc-has-error').removeClass('opc-has-success');
            const delivery_option_radio = $('.delivery_option_radio');
            const del_val = $('.delivery_option_radio:checked').val();
            if (del_val) { var sel_carrier = del_val.replace(',', ''); } else { var sel_carrier = 0; }
            const carterr = $('.err_isset').val();
            var error_pickup = false;
            var error_cart = false;
            var error_term = false;
            let error_carrier = true;
            var error_payment = false;
            let error_ajax = false;
            let payment_exec = true;
            if (maps_pickup_on && carrier_pickup == sel_carrier) {
                const idpickup = $('#pickup_center').val();
                if (idpickup == 0) {
                    $('#pickup_center').parents('.opc-form-group').first().addClass('opc-has-error');
                    var error_pickup = true;
                } else { $('#pickup_center').parents('.opc-form-group').first().addClass('opc-has-success'); }
            }

            if (carterr != '' && carterr != 0 && carterr != false) { var error_cart = true; }
            if (trm == 1 && !term_select) { var error_term = true; }
            if (!payment_method) { var error_payment = true; }

            if (!vcart) {
                $.each(delivery_option_radio, function (i) {
                    if ($(this).prop('checked')) { error_carrier = false; }
                });
            }
            const place_order_handler = function () {
                const dt = $('#orderform')
                    .find('#opc-left-content input, #opc-left-content select, #opc-right-pickup-content select, #opc-left-content textarea, #opc-right-carrier-content input, #opc-right-carrier-content select, #opc-right-carrier-content textarea, #opc_payment_methods input, #opc_payment_methods textarea, #opc-right-summary-content textarea')
                    .each(function (i) {
                        $(this).val($(this).val().trim());
                    })
                    .serialize();
                // return false;
                $.ajax({
                    type: 'POST',
                    url: `${orderOpcUrl}?rand=${new Date().getTime()}`,
                    async: false,
                    cache: false,
                    dataType: 'json',
                    data: dt,
                    success(json) {
                        $('.form-group').removeClass('form-group--error');
                        $('.form__error_wrapper').html('');
                        if (json.hasError) { error_ajax = true; }

                        if (error_carrier || error_payment || error_term || error_cart || error_pickup || error_ajax) {
                            let gtbs = '';
                            if (error_ajax) {
                                const $form = $('#new-acc');
                                for (const err in json.errors) {
                                    const typeTextArea = $form.find(`textarea[name="${err}"]`).length > 0;
                                    let formField = $form.find(`input[name="${err}"]`);
                                    if (typeTextArea) {
                                        formField = $form.find(`textarea[name="${err}"]`);
                                    }
                                    formField.closest('.form-group').find('.form__error_wrapper').html(json.errors[err]);
                                    formField.closest('.form-group').addClass('form-group--error');
                                }
                            }

                            if (error_carrier || error_payment) {
                                const txterror = [];
                                if (error_carrier && !vcart) {
                                    txterror.push(errc);
                                    $('.carrier_error').slideDown('slow');
                                    blinkForm($('.carrier_error'), 2);
                                }

                                if (error_payment) {
                                    txterror.push(errpym);
                                    $('.payment_error').slideDown('slow');
                                    blinkForm($('.payment_error'), 2);
                                }

                                if (txterror.length) {
                                    payment_exec = false;
                                    if (!gtbs) { gtbs = '#opc-right-content'; }
                                }
                            }

                            if (error_pickup) {
                                payment_exec = false;
                                if (!gtbs) { gtbs = '.opc-opd'; }
                            }

                            if (error_cart) {
                                payment_exec = false;
                                $('body').append(`<div id="opc-toast-container" class="al_err opc-toast-top-left clearfix"><div class="opc-toast fa-comments opc-toast-danger clearfix" style="opacity: 0.7995559618991;"><button class="opc-toast-close-button">×</button><div class="opc-toast-message">${isseterr}</div></div></div>`);
                                if (!gtbs) { gtbs = '#carterr:first'; }
                            }

                            if (error_term) {
                                payment_exec = false;
                                const source_term = $('input[name="cgv_accept"]').parents('.opc-form-group').first();
                                $(source_term).addClass('opc-has-error').find('.form__error_wrapper').html($(source_term).data('error-checked-required'));
                            }

                            if (gtbs) {
                                goToByScroll(gtbs);
                                if (error_cart) { blinkForm($('.carterr'), 3); }
                            }

                            setTimeout(() => {
                                $('.al_err').fadeOut(600, function () {
                                    $(this).remove();
                                });
                            }, 4000);
                            if ($('.form-group--error').length > 0) {
                                const scrollTop = $('.form-group--error').offset().top - $('header').outerHeight();
                                $('html, body').animate({ scrollTop });
                            }
                        }

                        if (!error_ajax) {
                            loadfield('');
                            loadpayment(payment_exec);
                        }
                    },
                    error(XMLHttpRequest, textStatus, errorThrown) {
                        alert(`TECHNICAL ERROR: unable to make order \n\nDetails:\nError thrown: ${XMLHttpRequest}\n` + `Text status: ${textStatus}`);
                    },
                });
            };
            if (payment_exec) {
                if ($(this).hasClass('js--check-phone')) {
                    $.ajax({
                        type: 'POST',
                        headers: { 'cache-control': 'no-cache' },
                        url: orderOpcUrl,
                        async: true,
                        cache: false,
                        dataType: 'json',
                        data: {
                            ajx: 1,
                            method: 'checkRegisteredCustomer',
                            phone: $('.opc-user-data input[name="phone"]').val().trim(),
                        },
                        success(rsp) {
                            if (rsp.result === 1) {
                                $('#modal_user_detected').modal('show');
                                $('#detected_name').text(rsp.name);
                            } else {
                                place_order_handler();
                            }
                        },
                    });
                } else {
                    place_order_handler();
                }
            }
        });
        $('.js--detect-user').keyup(function () {
            if ($(this).val().length === 19) {
                $.ajax({
                    type: 'POST',
                    headers: { 'cache-control': 'no-cache' },
                    url: orderOpcUrl,
                    async: true,
                    cache: false,
                    dataType: 'json',
                    data: {
                        ajx: 1,
                        method: 'checkRegisteredCustomer',
                        phone: $(this).val().trim(),
                    },
                    success(rsp) {
                        if (rsp.result === 1) {
                            $('#modal_user_detected').modal('show');
                            $('#detected_name').text(rsp.name);
                        }
                    },
                });
            }
        });
        $(document).on('click', '#user_detected_recovery', (e) => {
            e.preventDefault();
            $('#modal_user_detected').modal('hide');
            $('#modal_forgot_password').modal('show');
        });
        // $('.opc-login-button').on('click', function() {
        //     formHandler.checkoutLoginSend();
        // });
    },
};

export default formHandler;
